(function () {
  "use strict";

  // ----------------------------------------------------------------------------------------------------------------
  // HEADER CART ICON FALLBACK
  // ----------------------------------------------------------------------------------------------------------------
  //
  // Gokwik's own SDK (kwikcart/side-cart.js) attaches a capture-phase click listener directly on
  // the header cart-icon anchor and calls stopPropagation() there, before the theme's native
  // Dialog delegate (registered on document.body) ever sees the click. Gokwik intends this to
  // open its own sidecart instead of the theme drawer — but on this store that sidecart currently
  // fails to mount (no error thrown, it just silently does nothing), leaving clicks on the header
  // cart icon dead: neither UI opens.
  //
  // This listens on document in the CAPTURE phase (fires before Gokwik's own capture listener on
  // the anchor, since capture order runs outer -> inner) so it always sees the click regardless of
  // Gokwik's stopPropagation call. It polls for a while, then opens the native drawer as a
  // fallback only if nothing (neither Gokwik's sidecart nor the native drawer) actually opened.
  //
  // On a cold page load, Gokwik's sidecart genuinely takes longer than a fixed short delay to
  // mount (it's still fetching its own config/rendering while other scripts are also starting up),
  // so a single check too early wrongly concludes "nothing opened" and force-opens the native
  // drawer right on top of Gokwik's — a visible flash from Gokwik's cart to the native one. A
  // second click later in the same session (Gokwik already warmed up) doesn't hit this. Polling
  // repeatedly over a longer window instead of checking once early avoids stealing the open from
  // Gokwik while it's still mid-render.
  //
  // cart-drawer-gate.js (loaded just before this file) additionally patches CartDrawer.show() to
  // a no-op while it's waiting to confirm Gokwik's readiness, and once it observes Gokwik as
  // "ready" it locks that no-op in place for the rest of the page's life on the assumption Gokwik
  // will take over. Since Gokwik's sidecart is the thing that's actually broken, that patched
  // show() would silently swallow our fallback call too — so we force-release it first via the
  // gate's own public escape hatch before calling show().

  var POLL_INTERVAL_MS = 200;
  var FALLBACK_TIMEOUT_MS = 3000;

  function getShadowRoot() {
    var container = document.querySelector("shadow-dom-container");
    return container ? container.shadowRoot : null;
  }

  function sidecartMounted() {
    var sr = getShadowRoot();
    return sr ? !!sr.querySelector(".sidecart") : false;
  }

  document.addEventListener(
    "click",
    function (event) {
      var trigger =
        event.target.closest && event.target.closest('[aria-controls="cart-drawer"]');
      if (!trigger) return;

      var drawer = document.querySelector("cart-drawer");
      var elapsed = 0;

      var pollId = setInterval(function () {
        elapsed += POLL_INTERVAL_MS;
        var isMounted = sidecartMounted();
        var isOpen = drawer ? drawer.hasAttribute("open") : false;

        if (isMounted || isOpen) {
          clearInterval(pollId);
          return;
        }

        if (elapsed >= FALLBACK_TIMEOUT_MS) {
          clearInterval(pollId);
          if (drawer && typeof drawer.show === "function") {
            if (window.__zkCartGate && typeof window.__zkCartGate.forceRelease === "function") {
              window.__zkCartGate.forceRelease();
            }
            drawer.show();
          }
        }
      }, POLL_INTERVAL_MS);
    },
    true
  );
})();
